import React from 'react';
import * as AppActions from '../AppActions';
import * as JStorage from '../JStorage';

function deleteEmptyParams(params) {
  let next = {};
  for (let key in params) {
    let value = params[key];
    if (typeof value === 'object' && !Array.isArray(value) && value !== null) {
      // check is object
      let nested = deleteEmptyParams(value);
      if (Object.keys(nested).length > 0) {
        // check is non empty object
        next[key] = nested;
      }
    } else if (params[key]) {
      //check value exists
      next[key] = params[key];
    }
  }
  return next;
}

export default function useDocuments(props) {
  const {
    defaultFilters = {},
    collection,
    projection,
    sorting: _sorting = null,
  } = props;
  const [sorting] = React.useState(_sorting);
  const [records, setRecords] = React.useState([]);
  const [total, setTotal] = React.useState(0);
  const [filters, setFilters] = React.useState({
    ...defaultFilters,
    offset: 0,
    limit: defaultFilters.limit ?? 10, // default page size
  });
  const [loading, setLoading] = React.useState(false);

  const refresh = React.useCallback(async () => {
    AppActions.setLoading(true);
    setLoading(true);
    try {
      const {limit, offset, ...rest} = filters;

      const {total, results} = await JStorage.fetchDocuments(
        collection,
        deleteEmptyParams(rest),
        sorting,
        {
          limit,
          offset,
        },
        projection,
      );

      setTotal(total);
      setRecords(results);
    } catch (ex) {
      console.warn('REV_DBG', ex);
    }
    setLoading(false);
    AppActions.setLoading(false);
  }, [filters, sorting]);

  return {
    records,
    total,
    refresh,
    filters,
    setFilters,
    loading,
  };
}
